export default __webpack_public_path__ + "static/media/plus-button.3df9e71f.svg";